export const pointCollection = [
  [
    1.32,
    9.75,
    118.82,
    36.25,
    1.32,
    36.25,
    120.82,
    19.5,
    1.32,
    23.75,
    114.82,
    6.25,
    0.07,
    6
  ],
  [
    5.17,
    6,
    113.92,
    6,
    13.79,
    37.63,
    107.81,
    36.89,
    0.92,
    20.38,
    109.29,
    18.63,
    9.17,
    13.38,
    105.17,
    28.13,
    11.79,
    29.88
  ],
  [
    120.93,
    5.99,
    0.68,
    12.24,
    115.18,
    13.24,
    4.93,
    44.74,
    116.05,
    45.12,
    0.68,
    31.99,
    114.93,
    29.24,
    8.18,
    20.49,
    114.43,
    21.74
  ]
]



// WEBPACK FOOTER //
// ./src/core/icons/Highlighter/defaultProps.js